export default __webpack_public_path__ + "static/media/88.831b244f.gif";